/** Bound a tiny settings request; uncertain writes require an explicit reload. */
export const FEATURE_ROLLOUT_REQUEST_TIMEOUT_MS = 10000;

/** Build-time eligibility only controls presentation; the server authorizes writes. */
export function isFeatureRolloutLocal(localId: number): boolean {
  const raw = process.env.REACT_APP_FEATURE_ROLLOUT_ELIGIBLE_LOCAL_ID;
  if (!raw || !/^[1-9]\d*$/.test(raw)) return false;
  const eligible = Number(raw);
  return Number.isSafeInteger(eligible) && eligible === localId;
}

/** Only a scoped server projection can select a published menu on initial load. */
export function opensDirectMenu(
  localId: number,
  response: { local_id?: unknown; direct_menu_enabled?: unknown },
  config: { show_pdf_menu?: boolean; show_menu?: boolean },
  pdfUrl: string | null,
): boolean {
  return isFeatureRolloutLocal(localId)
    && response.local_id === localId
    && response.direct_menu_enabled === true
    && ((config.show_pdf_menu === true && Boolean(pdfUrl)) || config.show_menu === true);
}

/** Copy catalog for the existing Spanish-only digital-point settings screen. */
export const directMenuMessages = {
  title: 'Acceso directo a la carta',
  description: 'Los enlaces y QR existentes abrirán la carta publicada. No modifica precios ni publica menús ocultos.',
  enable: 'Abrir la carta directamente al escanear el QR',
  loading: 'Cargando configuración de acceso directo…',
  saving: 'Guardando configuración…',
  empty: 'Sin configuración guardada: el acceso directo está desactivado.',
  unavailable: 'No se pudo confirmar la configuración. Recarga antes de modificarla.',
  conflict: 'Otro administrador cambió la configuración. Recarga antes de modificarla.',
  retry: 'Recargar configuración',
  saved: 'Configuración de acceso directo guardada.',
} as const;

/** Same operator interaction for the independently enabled staff tip projection. */
export const staffTipsSettingMessages = {
  ...directMenuMessages,
  title: 'Propinas para el equipo',
  description: 'Muestra solo las propinas cobradas de la sesión activa, sin ventas ni datos de clientes.',
  enable: 'Mostrar propinas de la sesión a los garzones',
  loading: 'Cargando configuración de propinas…',
  empty: 'Sin configuración guardada: el indicador de propinas está desactivado.',
  saved: 'Configuración de propinas guardada.',
};

/** Bound foreground polling without tying operating sessions to calendar dates. */
export const STAFF_TIPS_REFRESH_MS = 30000;
export const directMenuViewerMessages = {
  unavailable: 'No se pudo abrir la carta.',
  retry: 'Volver a cargar la carta',
};
export const staffTipsMessages = {
  title: 'Propinas de la sesión',
  loading: 'Consultando propinas…',
  noSession: 'Sin sesión activa',
  unavailable: 'Propinas no disponibles',
  retry: 'Actualizar propinas',
  session: 'Sesión',
};
